import { QueuedItemStatus } from './QueuedItemStatus';

export interface GoogleAdsRequestBatchGq {
  readonly id: number;
  readonly requestId: number;

  // Source
  readonly source: string | null;
  readonly sourceId: number | null;

  // Processing info
  readonly status: QueuedItemStatus;
  readonly processingAttempts: number;
  readonly statusTime: string | null;
  readonly errorMessage: string | null;
}

export const GoogleAdsRequestBatchGqProps = `
    id
    requestId
    source
    sourceId
    status
    processingAttempts
    statusTime
    errorMessage
`;
